class CarouselFiftyFiftyMobile extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.initSlider()

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", this.onTabClick.bind(this))
    })

    this.updateActiveTab(0)
    this.updateActiveText(0)
  }

  onTabClick(event) {
    const index = parseInt(event.currentTarget?.getAttribute("data-index") || "0")
    this.sliderElement.slideTo(index)
  }

  updateActiveTab(index) {
    this.tabs.forEach((tab) => {
      if (tab.getAttribute("data-index") != index) {
        tab.classList.remove("active")
        tab.setAttribute("aria-selected", false)
      } else {
        tab.classList.add("active")
        tab.setAttribute("aria-selected", true)
      }
    })
  }

  updateActiveText(index) {
    this.textWrappers.forEach((text) => {
      if (text.getAttribute("data-index") != index) {
        text.classList.remove("active")
      } else {
        text.classList.add("active")
      }
    })
  }

  handleSlideChange(swiper) {
    this.updateActiveTab(swiper.activeIndex)
    this.updateActiveText(swiper.activeIndex)
  }

  initSlider() {
    this.sliderElement = new Swiper(this.querySelector(".js-slider"), {
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      slidesPerView: 1.3,
      spaceBetween: 15,
      slidesOffsetBefore: 14,
      slidesOffsetAfter: 14,
      on: {
        slideChange: this.handleSlideChange.bind(this),
      },
    })
  }

  get tabs() {
    return this.querySelectorAll(".js-tab-item")
  }

  get textWrappers() {
    return this.querySelectorAll(".js-text-wrapper")
  }
}

customElements.define("carousel-fifty-fifty-mobile", CarouselFiftyFiftyMobile)
